<script setup lang="ts">
import { TOTAL_STEPS } from '~/composables/useOfferteWizard'

const { step, submitting, goBack, goNext, submit, fieldErrors } = useOfferteWizard()

async function onNext() {
  if (step.value === TOTAL_STEPS) {
    const res = await submit()
    if (!res.ok && res.error && res.error !== 'consent') {
      fieldErrors.value = { _submit: 'Er ging iets mis bij het versturen. Probeer het opnieuw.' }
    }
  } else {
    goNext()
  }
}
</script>

<template>
  <div class="pa-wizard__nav">
    <button
        type="button"
        class="pa-btn pa-wizard__nav-back"
        :class="{ 'pa-wizard__nav-back--hidden': step === 1 }"
        @click="goBack"
    >
      ← Vorige
    </button>
    <div class="pa-wizard__nav-right">
      <span class="pa-wizard__nav-count">Stap {{ step }} van {{ TOTAL_STEPS }}</span>
      <button
          type="button"
          class="pa-btn pa-btn--secondary pa-wizard__nav-next"
          :disabled="submitting"
          @click="onNext"
      >
        <span v-if="step === TOTAL_STEPS">{{ submitting ? 'Versturen…' : 'Verstuur aanvraag →' }}</span>
        <span v-else>Volgende →</span>
      </button>
    </div>
    <p v-if="fieldErrors._submit" class="pa-wizard__error pa-wizard__error--block pa-wizard__nav-error">
      {{ fieldErrors._submit }}
    </p>
  </div>
</template>
